import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "single-row-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.75 21.5C2.78379 21.5 2 20.7162 2 19.75L2 3.75C2 2.78379 2.78379 2 3.75 2H5.75C6.71621 2 7.5 2.78379 7.5 3.75L7.5 19.75C7.5 20.7162 6.71621 21.5 5.75 21.5H3.75ZM3.5 19.75C3.5 19.8878 3.61221 20 3.75 20H5.75C5.88779 20 6 19.8878 6 19.75L6 3.75C6 3.61221 5.88779 3.5 5.75 3.5H3.75C3.61221 3.5 3.5 3.61221 3.5 3.75L3.5 19.75Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.75 21.5C9.78379 21.5 9 20.7162 9 19.75V3.75C9 2.78379 9.78379 2 10.75 2H12.75C13.7162 2 14.5 2.78379 14.5 3.75L14.5 19.75C14.5 20.7162 13.7162 21.5 12.75 21.5H10.75ZM10.5 19.75C10.5 19.8878 10.6122 20 10.75 20H12.75C12.8878 20 13 19.8878 13 19.75L13 3.75C13 3.61221 12.8878 3.5 12.75 3.5H10.75C10.6122 3.5 10.5 3.61221 10.5 3.75L10.5 19.75Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16 19.75C16 20.7162 16.7838 21.5 17.75 21.5H19.75C20.7162 21.5 21.5 20.7162 21.5 19.75V3.75C21.5 2.78379 20.7162 2 19.75 2H17.75C16.7838 2 16 2.78379 16 3.75V19.75ZM17.75 20C17.6122 20 17.5 19.8878 17.5 19.75V3.75C17.5 3.61221 17.6122 3.5 17.75 3.5H19.75C19.8878 3.5 20 3.61221 20 3.75V19.75C20 19.8878 19.8878 20 19.75 20H17.75Z"
    }, null, -1)
  ])))
}
export default { render: render }